import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

/**
 * Use Current location name
 *  Get current location from the audit locations
 *  If the location is not found return an empty string
 */

export default () => {
    const { typesList, auditLocations } = useSelector((state) => state);
    const { auditId } = useParams();

    return useMemo(() => {
        if (!auditLocations?.data || !typesList?.branchTypes?.data) return "";

        const currentLocation = auditLocations.data.find(
            (item) => item?.audit?.id === parseInt(auditId)
        );

        if (!currentLocation) return "";

        const getBranchTypeName = (branchId) => {
            const res = typesList.branchTypes.data.find(
                (item) => item?.id === branchId
            );
            return res ? `${res.name} - ${res.ref}` : "";
        };

        const branchType = getBranchTypeName(
            currentLocation?.audit?.brandOperation?.branchType
        );

        return `${branchType} ${currentLocation?.location?.name || ""}`;
    }, [typesList, auditLocations, auditId]);
};
